import React from 'react';
import Datetime from 'react-datetime';
import * as firebase from 'firebase';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import ColorPicker from '../color-picker/color-picker';
import ImageUploader from '../image-uploader/image-uploader';
import './react-datetime.css';
import './expo-editor.css';

/** @class ExpoMetadata
  * A react component for editing a virutal expo's metadata
  */
export default class ExpoMetadata extends ReactFireComponent {
  /** @constructor
    * Creates a new instance of ExpoMetadata
    */
  constructor(props) {
    super(props);
    this.state = {
      metadata: {
        name: '',
        host: '',
        opens: undefined,
        closes: undefined,
        icon: undefined,
        logo: undefined,
        registry: false,
        showcase: false,
        archived: false,
        palette: ['blue','blue','blue','blue','blue']
      }
    };
    this.firebaseRef = firebase.database().ref(this.props.dataURL);
    this.handleChange = this.handleChange.bind(this);
    this.handleDatetimeChange = this.handleDatetimeChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to its firebase realtime
    * database entry
    */
  componentWillMount(){
    this.bindAsObject(this.props.dataURL, 'metadata');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount(){
    this.unbind('metadata');
  }
  /** @function handleChange
    * Updates the state of the component based on
    * input field events.
    * @param {InputEvent} event - the event to respond to
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    var metadata = this.state.metadata;
    metadata[name] = value;
    this.setState({
      metadata: metadata
    });
  }
  /** @function handleDatetimeChange
    * Updates the state of the component to reflect
    * a change in a datetime field.
    * @param {string} name - the name of the property to update
    * @param {Moment} moment - a Moment.js object representing the
    * new datetime value.
    */
  handleDatetimeChange(name, moment) {
    var metadata = this.state.metadata;
    metadata[name] = moment.valueOf();
    this.setState({
      metadata: metadata
    });
  }
  /** @function handleBlur
    * Applies the updated state to the firebase database
    */
  handleBlur() {
    this.firebaseRef.set(this.state.metadata);
  }
  /** @function handleImageUpload
    * Applies uploaded images to the state and
    * saves them to the database.
    */
  handleImageUpload(name, url) {
    var metadata = this.state.metadata;
    metadata[name] = url;
    this.setState({
      metadata: metadata
    }, () => this.handleBlur());
  }
  /** @method handleColorChange
    * Applies the color to the palette slot
    * @param {integer} index - the palette slot
    * @param {string} color - the color
    */
  handleColorChange(index, color) {
    var metadata = this.state.metadata;
    metadata.palette[index] = color;
    this.setState({
      metadata: metadata
    }, () => this.handleBlur());
  }
  /** @function render
    * Renders the component
    */
  render() {
    return (
      <div className="metadata-panel">
        <div className="metadata-column">
          <div className="input-group">
            <label htmlFor="name">Name</label><br/>
            <input type="text" name="name"
              value={this.state.metadata.name}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />
          </div>
          <div className="input-group">
            <label htmlFor="host">Host</label><br/>
            <input type="text" name="host"
              value={this.state.metadata.host}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />
          </div>
          <div className="input-group">
            <label htmlFor="opens">Opens</label><br/>
            <Datetime
              value={new Date(this.state.metadata.opens)}
              locale="en"
              closeOnSelect={true}
              onChange={(moment)=>this.handleDatetimeChange("opens", moment)}
              onBlur={this.handleBlur}
              />
          </div>
          <div className="input-group">
            <label htmlFor="closes">Closes</label><br/>
            <Datetime
              value={new Date(this.state.metadata.closes)}
              locale="en"
              closeOnSelect={true}
              onChange={(moment)=>this.handleDatetimeChange("closes", moment)}
              onBlur={this.handleBlur}
              />
          </div>
          
          <div className="input-group">
            <label htmlFor="showcase">
              <input type="checkbox" name="showcase"
                checked={this.state.showcase}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                />
              Enable Product Showcase
            </label>
          </div>
          <div className="input-group">
            <label htmlFor="registry">
              <input type="checkbox" name="registry"
                value={this.state.registry}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                />
              Enable Gift Registry
            </label>
          </div>
          <div className="input-group">
            <label htmlFor="archived">
              <input type="checkbox" name="archived"
                value={this.state.archived}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                />
              Archived
            </label>
          </div>
        </div>
        <div className="metadata-column">
          <div className="input-group">
            <ImageUploader
              name="Icon"
              value={this.state.metadata.icon}
              dataURL={this.props.dataURL + '/icon'}
              onUpload={(url)=>this.handleImageUpload('icon', url)}
              />
          </div>
          <div className="input-group">
            <ImageUploader
              name="Logo Image"
              value={this.state.metadata.logo}
              dataURL={this.props.dataURL + '/logo'}
              onUpload={(url)=>this.handleImageUpload('logo', url)}
              />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/expo-editor/expo-metadata.js